import { MetaSiteSearchWeb } from '@wix/ambassador-meta-site-search-web/http';
import { getDevelopmentSites, createDevelopmentSite, } from '@wix/ambassador-devcenter-dsm-v1-development-site/http';
import siteTemplates from './siteTemplates.json';
const metaSiteSearchService = MetaSiteSearchWeb('/meta-site-search-web').MetaSiteSearchApiV2();
export const getTestAppData = async (httpClient) => {
    const { data } = await httpClient.request(getDevelopmentSites({}));
    const countTotalWixSites = (await metaSiteSearchService().count({})).count;
    const testAppData = {
        siteTemplates,
        countDevelopmentSites: data.developmentSites
            ? data.developmentSites?.length
            : 0,
        countTotalWixSites: countTotalWixSites ? Number(countTotalWixSites) : 0,
    };
    return testAppData;
};
export const createDeveloperSite = async (httpClient, templateId) => {
    const response = await httpClient.request(createDevelopmentSite({ templateId }));
    return response;
};
//# sourceMappingURL=getTestAppData.js.map